import { render } from "./SaveAsSetButton.vue?vue&type=template&id=c07387f0&scoped=true"
import script from "./SaveAsSetButton.vue?vue&type=script&lang=js"
export * from "./SaveAsSetButton.vue?vue&type=script&lang=js"

import "./SaveAsSetButton.vue?vue&type=style&index=0&id=c07387f0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c07387f0"]])

export default __exports__